import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Combobox } from "@/components/ui/combobox";
import { toast } from "sonner";
import { FolderPlus, FileText, Check } from "lucide-react";

const isPdf = (a) => a.url && ((a.content_type || "").toLowerCase().includes("pdf") || (a.filename || "").toLowerCase().endsWith(".pdf"));

export const InboxPdfToDossier = ({ msg }) => {
  const pdfs = (msg.attachments || []).filter(isPdf);
  const [dossiers, setDossiers] = useState(null);
  const [pick, setPick] = useState("");
  const [done, setDone] = useState({});
  const [busy, setBusy] = useState("");

  if (!pdfs.length || !msg.assigned_tenant_id) return null;

  const load = async () => {
    if (dossiers) return;
    try {
      const r = await api.get(`/tenants/${msg.assigned_tenant_id}/dossiers`);
      setDossiers(r.data);
      if (r.data[0]) setPick(r.data[0].id);
    } catch { setDossiers([]); }
  };

  const add = async (a, i) => {
    if (!pick) { toast.error("Kies eerst een dossier"); return; }
    setBusy(String(i));
    try {
      await api.post(`/dossiers/${pick}/entries`, { type: "file", file_url: a.url, file_name: a.filename || "bijlage.pdf" });
      setDone((d) => ({ ...d, [`${pick}:${i}`]: true }));
      toast.success(`${a.filename || "Bijlage"} toegevoegd aan dossier`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Toevoegen mislukt"); }
    setBusy("");
  };

  if (dossiers === null) {
    return (
      <Button size="sm" variant="outline" className="mt-2" onClick={load} data-testid={`inbox-pdf-dossier-open-${msg.id}`}>
        <FolderPlus className="h-4 w-4 mr-1.5" /> PDF-bijlagen naar dossier ({pdfs.length})
      </Button>
    );
  }
  if (!dossiers.length) {
    return <p className="mt-2 text-xs text-slate-500" data-testid={`inbox-pdf-dossier-none-${msg.id}`}>Deze debiteur heeft nog geen dossier. Maak eerst een dossier aan in het debiteurprofiel.</p>;
  }
  return (
    <div className="mt-2 border rounded-lg p-3 bg-slate-50 space-y-2" data-testid={`inbox-pdf-dossier-panel-${msg.id}`}>
      <div className="w-full sm:w-80">
        <Combobox testId={`inbox-pdf-dossier-select-${msg.id}`} value={pick} onChange={setPick}
          options={dossiers.map((d) => ({ value: d.id, label: `${d.number} — ${d.title}` }))} />
      </div>
      {pdfs.map((a, i) => {
        const cur = dossiers.find((d) => d.id === pick);
        const ok = done[`${pick}:${i}`] || (cur?.entries || []).some((e) => e.file_url === a.url);
        return (
          <div key={i} className="flex items-center justify-between gap-2 text-sm">
            <span className="flex items-center gap-1.5 min-w-0"><FileText className="h-4 w-4 text-red-500 shrink-0" /><span className="truncate">{a.filename || "bijlage.pdf"}</span></span>
            <Button size="sm" variant={ok ? "ghost" : "outline"} disabled={ok || busy === String(i)} onClick={() => add(a, i)} data-testid={`inbox-pdf-dossier-add-${msg.id}-${i}`}>
              {ok ? <><Check className="h-4 w-4 mr-1 text-emerald-600" /> Toegevoegd</> : <><FolderPlus className="h-4 w-4 mr-1" /> Naar dossier</>}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
